var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-autocomplete",
    _vm._b(
      {
        staticClass: "mt-0",
        attrs: {
          "persistent-hint": "",
          clearable: "",
          label: _vm.label,
          loading: _vm.loading || _vm.qbLoading,
          disabled: _vm.disabled,
          "item-text": "selectDisplay",
          items: _vm.entries,
          "return-object": ""
        },
        on: {
          input: function($event) {
            return _vm.$emit("input", $event)
          },
          change: function($event) {
            return _vm.$emit("change", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(slotItems) {
              return [
                _c("v-layout", { attrs: { column: "" } }, [
                  _c("div", { staticClass: "title mr-3 mt-1 primary--text" }, [
                    _vm.customerCompanyName(slotItems.item)
                      ? _c(
                          "span",
                          [
                            slotItems.item.qbCompanyId
                              ? _c("v-icon", { attrs: { color: "primary" } }, [
                                  _vm._v("business")
                                ])
                              : _c(
                                  "v-icon",
                                  { attrs: { color: "transparent" } },
                                  [_vm._v("add_circle")]
                                ),
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.customerCompanyName(slotItems.item)
                                ) +
                                "\n        "
                            )
                          ],
                          1
                        )
                      : _c(
                          "span",
                          [
                            _c("v-icon", { attrs: { color: "primary" } }, [
                              _vm._v("person_outline")
                            ]),
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.customerDisplayName(slotItems.item)
                                ) +
                                "\n        "
                            )
                          ],
                          1
                        )
                  ]),
                  _vm._v(" "),
                  _vm.customerCompanyName(slotItems.item) &&
                  _vm.customerContactName(slotItems.item)
                    ? _c(
                        "div",
                        { staticClass: "grey--text caption" },
                        [
                          _c("v-icon", { attrs: { color: "primary" } }, [
                            _vm._v("person_outline")
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.customerContactName(slotItems.item))
                            )
                          ]),
                          _vm._v(" "),
                          _vm.customerCompanyName(slotItems.item) !==
                          _vm.customerDisplayName(slotItems.item)
                            ? _c(
                                "span",
                                {
                                  staticClass: "font-italic font-weight-light"
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.customerDisplayName(slotItems.item)
                                      ) +
                                      "\n        "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            }
          }
        ])
      },
      "v-autocomplete",
      _vm.$attrs,
      false
    ),
    [
      _vm._v(" "),
      _c(
        "template",
        { slot: "append-outer" },
        [
          _c(
            "v-btn",
            {
              staticClass: "ma-0",
              attrs: {
                fab: "",
                small: "",
                flat: "",
                color: "accent",
                loading: _vm.loading || _vm.qbLoading
              },
              on: {
                click: function($event) {
                  return _vm.refresh()
                }
              }
            },
            [_c("v-icon", [_vm._v("refresh")])],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2361a436", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2361a436","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/qb/SelectQuickbooksCompany.vue
// module id = null
// module chunks = 